import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { ArchiveFolderActionData } from 'src/app/components/designer/models/archive-folder-action-data';
import { FormMode } from '../../common/form-mode';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { WorkflowDataInterface } from '../workflow-data.interface';

@Component({
    selector: 'app-workflow-action-archive-folder-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, FaIconComponent, MatTooltipModule, MatCheckboxModule],
    templateUrl: './workflow-action-archive-folder-data.component.html',
    styleUrl: './workflow-action-archive-folder-data.component.scss',
})
export class WorkflowActionArchiveFolderDataComponent implements WorkflowDataInterface, OnInit {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: ArchiveFolderActionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | ArchiveFolderActionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as ArchiveFolderActionData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): ArchiveFolderActionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            waitingArchiveModeEnabled: new UntypedFormControl(false),
        });

        if (this.mode === FormMode.Reading) {
            this.dataForm.disable();
        } else {
            this.dataForm.enable();
        }

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                this.dataForm.get('waitingArchiveModeEnabled').setValue(this._data.waitingArchiveModeEnabled);
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: ArchiveFolderActionData = new ArchiveFolderActionData();
        updatedData.waitingArchiveModeEnabled = this.dataForm.get('waitingArchiveModeEnabled').value;

        this._data = updatedData;
    }
}
